import React from 'react';

import './Card.scss';

export const CardInterior = ({titulo ,contenido, className = '',  style = {}, styleTitle= {}}) => {
   return (
    <div className={`card bg-Card ${className}`} style={{ padding:0, justifyContent:"center", marginTop:18, ...style}}>
        <div className='card-header text-truncate' style={styleTitle}>
           <span>{titulo}</span>
        </div>
        <div className={'pt-2 px-2 pb-1 cardContenido'} style={style}>
           {contenido}
        </div>
    </div>
   );
}
export default CardInterior;